import React from "react";

import { useParams } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import { useFetchSocieteQuery } from "../../../redux/slice/api/FO/societeApi";
import MarqueDetails from "./MarqueDetails";
import { Type_Return_Message } from "../../../models/interfaces/IReturn_Parent";
import CpntDetailsNotAccess, { TypeAffichage } from "../../../components/CpntDetailsNotAccess";
import SpinnerEditeurPro from "../components/SpinnerEditeurPro";
import CpntNavigatorSociete from "../components/CpntNavigatorSociete";



const PageMarqueDetails: React.FC = () => {

  let { idmarque: idmarque } = useParams();
  idmarque = idmarque ?? "";
  
  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
  
    const { data: MarqueResult, isFetching } = useFetchSocieteQuery(idmarque, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || idmarque === null || idmarque === "",
    });


    if (isFetching) {
      return (
        <SpinnerEditeurPro />
      )
    }


  return (
    <>
    {
MarqueResult && MarqueResult?.Return_IdType_Message === Type_Return_Message.Erreur ?
      <>
      <CpntDetailsNotAccess text="Aucune marque Electre trouvée." typeAffichage={TypeAffichage.Societe}/>
      </>
:
<div className="container">
{
        MarqueResult?.Societe?.Id && 
        <div className="row">
          <div className="col-9 mt-2 d-flex justify-content-start">
          {<>Votre contact :&nbsp;<b>{MarqueResult?.SuiviPar ? MarqueResult?.SuiviPar : 'biblio@electre.com'}</b></>} 
          </div>
          
          {
            <div className="col-3 mt-2 d-flex justify-content-end">
            <div className="me-2">
            <CpntNavigatorSociete
            currentValueIdMarque={MarqueResult?.Societe?.Id}
            datas={(() => {
              const storedData = localStorage.getItem("MarquesNavigator");
              try {
                const parsedData = storedData ? JSON.parse(storedData) : [];
                return Array.isArray(parsedData) ? parsedData : [];
              } catch {
                return [];
              }
            })()}
            />
            </div>
          </div>
          }
        </div>
        
    }
    <>
    {/* navigatorPath="../marquedetails/" */}
    <MarqueDetails MarqueResult={MarqueResult} isFetchingMarqueResult={isFetching} btnModifierVisible={true} ></MarqueDetails> 
    </>
  
</div>
}
</>
  );
  
};

export default PageMarqueDetails;
